export default {
    // 更新用户信息
    UPDATE_USERINFO(state, userInfo) {
        state.userInfo = userInfo;
    }
}
